import { Textarea } from '@cian/ui-kit';
import { IconActionArrowUp16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { useMessageInput, MAX_MESSAGE_LENGTH } from './useMessageInput';
import { RoundActionButton } from '../RoundActionButton';

type TMessageInputFieldProps = {
  chatId: string;
  leftButton: React.ReactNode | null;
  replyTemplateButton: React.ReactNode | null;
  captcha?: React.ReactNode | null;
  isLoading: boolean;
  isInputDisabled: boolean;
  isSendButtonDisabled: boolean;
  onSend(params: { text: string; chatId: string; captchaToken?: string | null; payload?: string }): void;
  onHeightChange(): void;
  placeholder?: string;
  inputRef?: React.Ref<HTMLTextAreaElement>;
  replyQuote: React.ReactNode;
};

export const MessageInputField: React.FC<TMessageInputFieldProps> = ({
  chatId,
  captcha,
  leftButton,
  isLoading,
  isInputDisabled,
  isSendButtonDisabled,
  onSend,
  onHeightChange,
  placeholder,
  replyTemplateButton,
  inputRef,
  replyQuote,
}) => {
  const { text, onKeyDown, onValueChange, onBlur, onFocus, trySend } = useMessageInput({
    chatId,
    isSendButtonDisabled,
    onSend,
    onHeightChange,
  });

  const isSendButtonActive = isLoading || Boolean(text.trim().length && !isSendButtonDisabled);

  return (
    <div className={styles['container']} data-name="MessageInputField">
      {replyQuote}
      <div className={styles['wrapper']}>
        {captcha && <div className={styles['captcha']}>{captcha}</div>}
        <div className={styles['inner-container']}>
          {leftButton}
          <Textarea
            value={text}
            onChange={onValueChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            onFocus={onFocus}
            placeholder={placeholder || 'Написать сообщение'}
            disabled={isInputDisabled || isLoading}
            maxRows={10}
            minRows={1}
            maxLength={MAX_MESSAGE_LENGTH}
            size="M"
            data-name="MessageInputField_textarea"
            inputRef={inputRef}
          />
          {replyTemplateButton}
          <RoundActionButton
            theme={isSendButtonActive ? 'primary' : 'secondary'}
            isDisabled={!text.trim().length || isSendButtonDisabled}
            isLoading={isLoading}
            onClick={trySend}
            dataName="MessageInputField_send_button"
            dataTestId="send_button"
          >
            <IconActionArrowUp16 color="current_color" />
          </RoundActionButton>
        </div>
      </div>
    </div>
  );
};
